(() => {
  // Keep calculations independent of product prices: Markets can set fixed catalog prices.
  const calculate = ({ baseThreshold, actualThreshold = baseThreshold, baseCurrency, currency, country, rate, activeCurrency, overrides, actualOverrides = overrides, total }) => {
    if (!Number.isFinite(total) || total < 0) return null;
    const localThreshold = (base, localOverrides) => {
    const entries = new Map();
    String(localOverrides || '').split(/[\n,;]/).forEach(line => {
      const [key, amount] = line.split('=').map(part => part.trim());
      if (!key || !amount) return;
      const value = Number(amount);
      if (Number.isFinite(value) && value > 0) entries.set(key.toUpperCase(), value);
    });
    const override = entries.get(`${country}:${currency}`) ?? entries.get(currency);
    let threshold;
    if (override !== undefined) {
      threshold = Math.round(override * 100);
    } else {
      if (!Number.isFinite(base) || base <= 0) return null;
      if (currency === baseCurrency) rate = 1;
      else if (activeCurrency !== currency || !Number.isFinite(rate) || rate <= 0) return null;
      threshold = Math.round(base * 100 * rate);
    }
    if (threshold <= 0) return null;
    return threshold;
    };
    const threshold = localThreshold(baseThreshold, overrides);
    const unlockThreshold = localThreshold(actualThreshold, actualOverrides);
    if (threshold === null || unlockThreshold === null) return null;
    return {
      threshold,
      unlockThreshold,
      remaining: Math.max(0, threshold - total),
      progress: Math.min(100, Math.max(0, total / threshold * 100)),
      unlocked: total >= unlockThreshold,
      awaitingConfirmation: total >= threshold && total < unlockThreshold
    };
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = { calculate };
  if (typeof customElements === 'undefined' || customElements.get('cart-upsell-shipping')) return;

  customElements.define('cart-upsell-shipping', class extends HTMLElement {
    connectedCallback() {
      const currency = window.Shopify?.currency;
      const state = calculate({
        baseThreshold: Number(this.dataset.threshold),
        actualThreshold: Number(this.dataset.actualThreshold),
        baseCurrency: this.dataset.baseCurrency,
        currency: this.dataset.currency,
        country: this.dataset.country,
        rate: Number(currency?.rate),
        activeCurrency: currency?.active,
        overrides: this.dataset.overrides,
        actualOverrides: this.dataset.actualOverrides,
        total: Number(this.dataset.total)
      });
      if (!state) return;
      let amount;
      try {
        amount = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.dataset.currency }).format(state.remaining / 100);
      } catch (error) {
        return;
      }
      const template = state.unlocked ? this.dataset.success : state.awaitingConfirmation ? this.dataset.pending : this.dataset.message;
      this.querySelector('[data-shipping-message]').textContent = template.replaceAll('[amount]', amount);
      const bar = this.querySelector('[data-shipping-progress]');
      bar.setAttribute('value', String(state.unlocked ? 100 : Math.min(90, state.progress)));
      bar.hidden = false;
      this.dataset.localThreshold = String(state.threshold);
      this.dataset.localUnlockThreshold = String(state.unlockThreshold);
      this.classList.toggle('is-unlocked', state.unlocked);
    }
  });
})();
